import { Services } from "../components/Services";
import { Gallery } from "../components/Gallery";

export const ServicesPage = () => {
  return (
    <>
      <Services />
      <Gallery />
    </>
  );
};
